gsap.registerPlugin(ScrollTrigger);

const CONFIG = {
    triggerPoint: "top 88%",
    ease: "power2.out",
    staggerBase: 0.12,
};

gsap.from(".about-image", {
    x: -70,
    opacity: 0,
    duration: 1.0,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".about-brand",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".about-content", {
    x: 70,
    opacity: 0,
    delay: 0.1,
    duration: 1.0,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".about-brand",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".feature", {
    opacity: 0,
    y: 35,
    duration: 0.65,
    stagger: CONFIG.staggerBase,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".about-features",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".heading", {
    opacity: 0,
    y: 50,
    duration: 0.8,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".care-craft",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".process-column:first-child .process-item", {
    opacity: 0,
    x: -60,
    stagger: CONFIG.staggerBase,
    duration: 0.75,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".process-wrapper",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".process-column:last-child .process-item", {
    opacity: 0,
    x: 60,
    stagger: CONFIG.staggerBase,
    duration: 0.75,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".process-wrapper",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".center-image", {
    scale: 0.78,
    opacity: 0,
    duration: 0.95,
    ease: "back.out(1.3)",
    clearProps: "transform,opacity",
    scrollTrigger: {
        trigger: ".center-image",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".impact-card", {
    opacity: 0,
    y: 35,
    stagger: 0.09,
    duration: 0.6,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".impact-strip",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".impact-heading", {
    opacity: 0,
    y: 40,
    duration: 0.75,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".impact-section",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".impact-box", {
    opacity: 0,
    y: 45,
    scale: 0.9,
    stagger: CONFIG.staggerBase,
    duration: 0.75,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".impact-grid",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".why-ghee .section-heading", {
    opacity: 0,
    y: 40,
    duration: 0.75,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".why-ghee",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".why-item", {
    opacity: 0,
    x: -70,
    stagger: CONFIG.staggerBase,
    duration: 0.7,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".why-content",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".why-image", {
    opacity: 0,
    scale: 0.88,
    rotate: 3,
    duration: 0.95,
    ease: "power3.out",
    clearProps: "transform,opacity",
    scrollTrigger: {
        trigger: ".why-image",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".testimonials .section-heading", {
    opacity: 0,
    y: 40,
    duration: 0.75,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".testimonials",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".faq-section .section-heading", {
    opacity: 0,
    y: 40,
    duration: 0.75,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".faq-section",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".faq-left", {
    opacity: 0,
    x: -60,
    duration: 0.9,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".faq-wrapper",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

gsap.from(".faq-item", {
    opacity: 0,
    y: 30,
    x: 20,
    stagger: 0.1,
    duration: 0.6,
    ease: CONFIG.ease,
    clearProps: "all",
    scrollTrigger: {
        trigger: ".faq-wrapper",
        start: CONFIG.triggerPoint,
        toggleActions: "play none none none",
    },
});

// ScrollTrigger.create({
//     trigger: ".center-image",
//     start: CONFIG.triggerPoint,
//     once: true,
//     onEnter: () => {
//         gsap.to(".center-image video, .center-image img", {
//             y: -10,
//             duration: 2.0,
//             repeat: -1,
//             yoyo: true,
//             ease: "sine.inOut",
//             delay: 1.0,
//         });
//     },
// });

ScrollTrigger.create({
    trigger: ".why-image",
    start: CONFIG.triggerPoint,
    once: true,
    onEnter: () => {
        gsap.to(".why-image img", {
            y: -10,
            duration: 2.0,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut",
            delay: 1.0,
        });
    },
});

const testimonialSwiper = new Swiper(".testimonialSwiper", {
    loop: true,
    speed: 600,
    spaceBetween: 30,
    grabCursor: true,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
    },

});

const faqItems = document.querySelectorAll(".faq-item");

faqItems.forEach((item) => {
    item.querySelector(".faq-question").onclick = () => {
        faqItems.forEach((i) => {
            if (i !== item) i.classList.remove("active");
        });
        item.classList.toggle("active");
    };
});

const menu = document.querySelector(".mobile-menu");
const overlay = document.querySelector(".mobile-menu-overlay");
const openBtn = document.querySelector(".mobile-toggle");
const closeBtn = document.querySelector(".mobile-close");
const custom_body = document.querySelector("body");

openBtn.addEventListener("click", () => {
    menu.classList.add("active");
    overlay.classList.add("active");
    custom_body.style.overflow = "hidden";
});

function closeMenu() {
    menu.classList.remove("active");
    overlay.classList.remove("active");
    document.body.style.overflow = "";
}

closeBtn.addEventListener("click", closeMenu);
overlay.addEventListener("click", closeMenu);